import React from "react";
import PasswordChanged from "../components/PasswordChanged/PasswordChanged"; // ✅ Default Import

const PasswordChangedPage = () => {
  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <PasswordChanged />
    </div>
  );
};

export default PasswordChangedPage; // ✅ Ensure correct export
